import React from 'react';
import { useIntl } from 'react-intl';
import { API } from '@gin-betting/core';

import messages from '../../../Categorizer/messages.js'; // TODO: probably need to move this in root translations
import BackLink from '../../BackLink';
import CountryTitle from '../CountryTitle';
import TournamentItem from '../TournamentItem';
import TournamentItemWrapper from '../TournamentItemWrapper';
import useActiveRegionItem from './useActiveRegionItem';

interface Props {
    tournaments: API.CategorizerItem[];
    countryCode: string;
    countryName: string;
    children: React.ReactNode[];
}

const ActiveRegionItem: React.FC<Props> = ({
    tournaments,
    countryCode,
    countryName,
    children,
}) => {
    const { formatMessage } = useIntl();
    const { handleClickBack, handleClickAll, totalCount } = useActiveRegionItem(
        {
            countryCode,
            tournaments,
        }
    );

    return (
        <React.Fragment>
            <BackLink
                title={
                    <CountryTitle
                        countryCode={countryCode}
                        countryName={countryName}
                    />
                }
                onClick={handleClickBack}
            />

            {tournaments.length > 1 && (
                <TournamentItemWrapper onClick={handleClickAll}>
                    <TournamentItem
                        count={totalCount}
                        title={formatMessage(messages.selectAll)}
                    />
                </TournamentItemWrapper>
            )}

            {children}
        </React.Fragment>
    );
};

export default ActiveRegionItem;
